import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack, IconClose } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import mediator from 'Utilities/mediator';
const InAppActionBar = ({ testID, title, closeBtn, onBack }) => {
    return (React.createElement(VStack, { style: {
            top: 0,
            left: 0,
            right: 0,
        }, backgroundColor: "$neutral.noChangeTransparent" },
        React.createElement(HStack, { padding: "$4", position: "relative" },
            React.createElement(IconButton, { position: "absolute", testID: `${testID}.back-btn`, onPress: () => {
                    onBack ? onBack() : mediator.publish('router:back');
                } }, closeBtn ? (React.createElement(IconClose, { testID: `${testID}.close-btn-icon`, color: "$text.100" })) : (React.createElement(IconBack, { testID: `${testID}.back-btn-icon`, color: "$text.100" }))),
            React.createElement(Text, { testID: `${testID}.title`, color: "$text.100", fontSize: "$h4.strong", fontWeight: "$h4.strong", width: "100%", alignSelf: "center", textAlign: "center", numberOfLines: 1 }, title))));
};
export { InAppActionBar };
